
import { computed } from 'vue';
import { data } from '~/node_modules/autoprefixer/lib/autoprefixer';

// add no-icon attribute to disable icons
export default {
  name: 'DisclosureCard',
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'disclosure',
    },
    iconType: {
      type: String,
      default: 'pdf',
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
    noDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ai_excluded_documents: [
        "31cb27ce-9a07-479f-9cfa-ea05085eae65#12573933-d129-41e6-b0b3-796f99dd70b5",
        "31cb27ce-9a07-479f-9cfa-ea05085eae65#fd541a34-cd84-4a3c-9fee-c27e3efdc907",
        "d1b49dc7-38e2-4a32-b4e3-3a3702762815#bff3031f-cfd2-47ec-a43b-81fd55819875",
        "21fee99a-0483-468b-b272-3a7d47c1f60a#0a89926d-653d-450a-9af1-1aefdcb15fb0",
        "61ec3249-21ac-4d95-935a-1e5fe6aa2d2e#961979bd-20b3-4870-b3db-2baeb13f7d0b",
        "84e2dc94-f1bd-43e6-8f05-494aeb7b3031#7724138f-f16d-442f-ac5b-363c298d578d",
        "cda82087-4795-4baf-9f2f-d55c05dcfc55#22f66653-23d3-4438-9326-b770bf407702",
        "ee4d436f-9743-4022-b81f-36f8f85cd29a#451b08c4-9c60-488c-b257-19df567e5ab8",
        "ea83d093-86d3-4140-9c29-280646a07716#42eb8ed3-8b8d-4d5a-9f32-af93f27d1e9a",
        "ea83d093-86d3-4140-9c29-280646a07716#8c99ece7-781d-42f7-8125-d636f0427635"
      ] // or nasdaq
    };
  },
  computed: {
    isYear2025() {
      //get the year from data. publication_date
      const year = this.$dayjs(this.data.publication_date).format('YYYY');
      return year === '2025';
    },
    showAiSummary() {
      const isDisclosure = this.data.announcement_type === 'Disclosure';
      const currentId = `${this.data?.id}#${this.data.resources[0]?.id}`;
      const isExcluded = this.ai_excluded_documents.includes(currentId);
      // Check if the document is from 2025
      const isFrom2025 = this.isYear2025;
      // Show AI summary if not excluded and not from 2025
      return !isExcluded && isDisclosure && isFrom2025;
    },
  },
}
